export default __webpack_public_path__ + "static/media/arrow-east.8e1a68bb.svg";